module.exports = {"TXTWCL_You_Cashed_Out_N0":{"id":"TXTWCL_You_Cashed_Out_N0","defaultMessage":"{0}  Kifizettetése megtörtént"}}